import { api } from "./api";

export const dashboardApi = (params) => {
  return api.get("/manufacturer/dashboard", { params });
};

export const analyticalReportDownloadApi = (params) => {
  return api.get(`/manufacturer/dashboard/download`, {
    params: params,
  });
};

export const graphCardApi = (params) => {
  console.log(params);
  return api.get(`/manufacturer/dashboard/${params.urlParams}`, {
    params,
  });
};

